<template>
    <div>
        <page-header title="Profiles Tested" ></page-header>

        <h4 class="mr-2">Sports Profiles Tested By Organizations ({{dateRange}})</h4>

        <div class="note-text">
            <span style="font-weight: 500">Note:</span> Distinct profiles tested during period. Does not matter if deleted, inactive, or active. Only tested profiles.
        </div>
        
        <AppCard hide-header class="pa-4">

            <v-row>
                <v-col :cols="4">
                    <AppFormDatePicker v-model="startDate" label="Start Date" :date-format="startDateFormat" />
                </v-col>
                <v-col :cols="4">
                    <AppFormDatePicker v-model="endDate" label="End Date" :date-format="endDateFormat" />
                </v-col>
            </v-row>
            <AppBtn style="" @click="getReport" :loading="loading">
                Get Test Volume Report
            </AppBtn>
            <!--				<app-fab-btn iconName="icon-download" @click="downloadReport" />-->



        </AppCard>
        <AppCard hide-header class="mt-4" v-if="rows.length > 0">
            <v-data-table :items="rows" :headers="headers" >
                <template v-slot:top>
                    <div class="pa-2">
                        <AppBtn small @click="copyCsv">Copy Table to Clipboard</AppBtn>
                    </div>
                </template>
            </v-data-table>
        </AppCard>

    </div>
</template>

<script>
import moment from "moment";
import {getTestVolumeReport} from "@/services/enterprise.service";
import {getBillingOverview, tryGetBillingOverview} from "@/services/billing.service";

export default {
    name: "TestVolumeReport",
    data() {
        return {
            startDate: null,
            endDate: null,
            loading: false,
            headers: [
                {
                    title: 'Org ID',
                    value: 'organizationId'
                },
                {
                    title: 'Org Name',
                    value: 'organizationName'
                },
                {
                    title: 'Tested Profile Count',
                    value: 'testedProfileCount'
                },
                {
                    title: 'Total Test Count',
                    value: 'totalTestCount'
                },
                {
                    title: 'Baseline Test Count',
                    value: 'baselineTestCount'
                },
                {
                    title: 'Non-Baseline Test Count',
                    value: 'nonBaselineTestCount'
                },
                {
                    title: 'Logged Events',
                    value: 'eventCount'
                },
            ],
            rows: [],
            startDateFormat: 'YYYY-MM-DD 12:00[AM] [CST]',
            endDateFormat: 'YYYY-MM-DD 12:00[AM] [CST]'
        }
    },
    mounted() {
        this.getInitialData();
    },
    methods: {
        async getInitialData() {

            const response = await tryGetBillingOverview();
            
            let startDate = moment().utc().subtract(1, 'years').format("YYYY-MM-DDT00:00:00");
            let endDate = moment().utc().format("YYYY-MM-DDT00:00:00");
            
            if (!response.isSuccess) {
                this.startDate = startDate;
                this.endDate = endDate;
                return
            }
            
            this.startDate = response.sportsPeriodStart ?? response.clinicalPeriodStart ?? startDate;
            this.endDate = response.sportsPeriodEnd ?? response.clinicalPeriodEnd ?? endDate;
            
            await this.getReport();
        },
        async getReport() {
            this.loading = true;

            const {startDate, endDate} = this;

            // const request = {
            // 	startDate,
            // 	endDate,
            // };

            const response = await getTestVolumeReport(startDate, endDate);

            this.rows = response.organizations

            this.loading = false;
        },

        copyCsv() {

            const {rows} = this;

            let arrayForCsv = []
            arrayForCsv.push(["Org ID", "Org Name", "Tested Profile Count", "Total Test Count", "Baseline Test Count", "Non-Baseline Test Count", "Logged Events"]);

            rows.forEach(org => {
                let orgRow = []
                for (let key in org) {
                    orgRow.push(org[key])
                }
                arrayForCsv.push(orgRow)

            })

            // Create a new textarea element to hold the copied text
            const textarea = document.createElement('textarea');

            // Convert the array of arrays to a string with tab and newline separators
            const text = arrayForCsv.map(row => row.join('\t')).join('\n');

            // Set the textarea's value to the copied text and append it to the document
            textarea.value = text;
            document.body.appendChild(textarea);

            // Select the textarea and copy its contents to the clipboard
            textarea.select();
            document.execCommand('copy');

            // Remove the textarea from the document
            document.body.removeChild(textarea);

        },
        formatDate(date) {
            return moment(date).format("M/D/YYYY");
        },
    },
    computed: {
        dateRange() {
            return this.formatDate(this.startDate) + " - " + this.formatDate(this.endDate)
        }
    }
}
</script>

<style scoped>
.note-text {
    font-size: 0.85rem;
    font-style: italic;
    color: #757575;
    margin-bottom: 16px;
}

.v-data-table :deep(thead) {
    background-color: var(--v-text-base) !important;
}

.v-data-table :deep(thead tr th) {
    color: white !important;
}
</style>